/* ============================================
   OVA SHOPIFY THEME — Global JavaScript
   ============================================ */

// Mobile menu toggle
document.addEventListener('DOMContentLoaded', function() {
  const mobileToggle = document.querySelector('.header__mobile-toggle');
  const nav = document.querySelector('.header__nav');

  if (mobileToggle && nav) {
    mobileToggle.addEventListener('click', function() {
      nav.classList.toggle('is-open');
      const isOpen = nav.classList.contains('is-open');
      mobileToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  // Accordion functionality
  document.querySelectorAll('.accordion-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const content = this.nextElementSibling;
      const isOpen = content.classList.contains('is-open');

      // Close all accordions in same group
      const parent = this.closest('.accordion-group');
      if (parent) {
        parent.querySelectorAll('.accordion-content').forEach(function(c) {
          c.classList.remove('is-open');
        });
        parent.querySelectorAll('.accordion-trigger').forEach(function(t) {
          t.setAttribute('aria-expanded', 'false');
        });
      }

      if (!isOpen) {
        content.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Scroll animation observer
  const animateElements = document.querySelectorAll('[data-animate]');
  if (animateElements.length > 0 && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in-up');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    animateElements.forEach(function(el) {
      el.style.opacity = '0';
      observer.observe(el);
    });
  }

  // Search overlay functionality
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchCloseButtons = document.querySelectorAll('[data-search-close]');
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');

  function openSearch() {
    if (searchOverlay) {
      searchOverlay.classList.add('is-open');
      searchOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function() {
        if (searchInput) searchInput.focus();
      }, 300);
    }
  }

  function closeSearch() {
    if (searchOverlay) {
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (searchInput) searchInput.value = '';
      // Reset results to show suggestions
      if (searchResults) {
        searchResults.innerHTML = '<div class="search-overlay__suggestions"><p class="search-overlay__suggestions-title">Popular Searches</p><div class="search-overlay__suggestions-list"><a href="/products/crickfresh" class="search-overlay__suggestion">CrickFresh</a><a href="/products/creaseline" class="search-overlay__suggestion">CreaseLine</a><a href="/collections/all" class="search-overlay__suggestion">All Products</a></div></div>';
      }
    }
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', openSearch);
  }

  searchCloseButtons.forEach(function(btn) {
    btn.addEventListener('click', closeSearch);
  });

  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('is-open')) {
      closeSearch();
    }
  });

  // Live predictive search
  var searchDebounceTimer;
  if (searchInput) {
    searchInput.addEventListener('input', function() {
      var query = this.value.trim();
      clearTimeout(searchDebounceTimer);

      if (query.length < 2) {
        // Show suggestions when query is too short
        if (searchResults) {
          searchResults.innerHTML = '<div class="search-overlay__suggestions"><p class="search-overlay__suggestions-title">Popular Searches</p><div class="search-overlay__suggestions-list"><a href="/products/crickfresh" class="search-overlay__suggestion">CrickFresh</a><a href="/products/creaseline" class="search-overlay__suggestion">CreaseLine</a><a href="/collections/all" class="search-overlay__suggestion">All Products</a></div></div>';
        }
        return;
      }

      searchDebounceTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5')
          .then(function(response) { return response.json(); })
          .then(function(data) {
            var products = data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : [];
            if (products.length === 0) {
              searchResults.innerHTML = '<div class="search-overlay__no-results">No results found for "' + query + '"</div>';
              return;
            }
            var html = '<div class="search-overlay__live-results">';
            products.forEach(function(product) {
              var imgSrc = product.image || '';
              html += '<a href="' + product.url + '" class="search-overlay__result-item">';
              if (imgSrc) {
                html += '<img src="' + imgSrc + '" alt="' + product.title + '" class="search-overlay__result-image" width="48" height="48">';
              }
              html += '<div class="search-overlay__result-info">';
              html += '<div class="search-overlay__result-title">' + product.title + '</div>';
              html += '<div class="search-overlay__result-price">' + (product.price ? '£' + parseFloat(product.price).toFixed(2) : '') + '</div>';
              html += '</div></a>';
            });
            html += '</div>';
            searchResults.innerHTML = html;
          })
          .catch(function() {
            searchResults.innerHTML = '<div class="search-overlay__no-results">Something went wrong. Please try again.</div>';
          });
      }, 300);
    });
  }
});
